import PropTypes from "prop-types";
import _last from "lodash/last";
import _isEmpty from "lodash/isEmpty";
import _get from "lodash/get";
import { Button, TimePicker } from "antd";
import {
  ClockCircleOutlined,
  CheckOutlined,
  CloseOutlined,
  MinusOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import moment from "moment";
import i18n from "i18n";
import { DAY_NUMBER } from "utils/constants";
import Helper from "utils/helpers";

const CustomOpenningTime = (props) => {
  const {
    workingTimeOfWeek,
    setWorkingTimeOfWeek,
    titleAlwaysOpen = "Luôn khuyến mãi",
    titleAlwaysClose = "Không khuyến mãi",
    onTimeCustomChange = () => {},
    fieldAlwaysOpen = "alwaysOpen",
    fieldAlwaysClose = "alwaysClose",
    canDisableSelectTimeSlot = false,
  } = props;
  const formatHours = "HH:mm";

  const handleChangeWorkingTimeOfWeek = (e) => {
    const workingTimeOfWeekUpdated = workingTimeOfWeek.map((item) => {
      if (e.day === item.key) {
        const timeWorkingUpdated =
          item?.time?.length > 0
            ? [...item.time, { shift: e.shift }]
            : [{ shift: e.shift }];
        return {
          ...item,
          time: timeWorkingUpdated,
          [fieldAlwaysOpen]: undefined,
          [fieldAlwaysClose]: undefined,
        };
      }
      return item;
    });
    setWorkingTimeOfWeek(workingTimeOfWeekUpdated);
  };

  const handleRemoveWorkingTimeOfWeek = (e) => {
    const workingTimeOfWeekUpdated = workingTimeOfWeek.map((item) => {
      if (e.day === item.key) {
        const timeWorkingUpdated = item.time.filter(
          (i) => i?._id !== e?._id || i?.shift !== e?.shift
        );
        return { ...item, time: timeWorkingUpdated };
      }
      return item;
    });
    setWorkingTimeOfWeek(workingTimeOfWeekUpdated);
  };

  const handleSetAlwaysOpen = (e) => {
    const workingTimeOfWeekUpdated = workingTimeOfWeek.map((item) => {
      if (e.day === item.key) {
        return {
          ...item,
          time: undefined,
          [fieldAlwaysClose]: undefined,
          [fieldAlwaysOpen]: true,
        };
      }
      return item;
    });
    setWorkingTimeOfWeek(workingTimeOfWeekUpdated);
  };

  const handleSetAlwaysClose = (e) => {
    const workingTimeOfWeekUpdated = workingTimeOfWeek.map((item) => {
      if (e.day === item.key) {
        return {
          ...item,
          time: undefined,
          [fieldAlwaysOpen]: undefined,
          [fieldAlwaysClose]: true,
        };
      }
      return item;
    });
    setWorkingTimeOfWeek(workingTimeOfWeekUpdated);
  };
  const handleOnchange = ({ e, day, shift }) => {
    const workingTimeOfWeekUpdated = workingTimeOfWeek.map((item) => {
      if (day === item.key) {
        const timeWorkingUpdated = item.time.map((i, indexOnDay) => {
          if (shift === indexOnDay) {
            return {
              ...i,
              from: moment(e[0]).format(formatHours),
              to: moment(e[1]).format(formatHours),
            };
          }
          return i;
        });
        return { ...item, time: timeWorkingUpdated };
      }
      return item;
    });
    onTimeCustomChange(workingTimeOfWeekUpdated);
  };

  const _handleApplyForAllWeek = (day) => {
    const updatedWorkingTime = workingTimeOfWeek.map((item) => ({
      ...item,
      time: day?.time,
      [fieldAlwaysOpen]: day?.[fieldAlwaysOpen],
      [fieldAlwaysClose]: day?.[fieldAlwaysClose],
    }));
    // Update local state
    setWorkingTimeOfWeek(updatedWorkingTime);
  };

  return (
    <div className="working-time-of-week-wrapper">
      {workingTimeOfWeek.map((day) => (
        <div key={day.key} className="working-time-of-day-container">
          <div className="working-time-of-day-label">{day.label} </div>
          <div className="working-time-of-day-value">
            {day?.[fieldAlwaysOpen] || day?.[fieldAlwaysClose] ? (
              <div className="no-working-time-wrapper">
                <div
                  className={`close-time-label ${
                    day?.[fieldAlwaysOpen] ? "alwaysOpen" : "alwaysClose"
                  }`}
                >
                  <ClockCircleOutlined />
                  {day?.[fieldAlwaysOpen] ? titleAlwaysOpen : titleAlwaysClose}
                </div>
                <Button
                  onClick={() =>
                    handleChangeWorkingTimeOfWeek({ day: day.key, shift: 0 })
                  }
                  className="add-working-time-btn"
                  type="primary"
                >
                  +
                </Button>
                <Button
                  onClick={() => _handleApplyForAllWeek(day)}
                  className="apply-for-all-week-working-time-btn"
                >
                  {i18n.t("menu.applyForAllWeek")}
                </Button>
              </div>
            ) : (
              <div className="day-working-time-wrapper">
                {day?.time?.map((item, index) => {
                  const beforeLastItem = _get(day, "time", []).slice(-2)[0];
                  const lastItem = _get(day, "time", []).slice(-1)[0];
                  let beforeLastItemTime = moment(
                    _get(beforeLastItem, "to", undefined)
                  );
                  if (
                    !beforeLastItemTime.isValid() &&
                    moment(
                      _get(beforeLastItem, "to", undefined),
                      formatHours
                    ).isValid()
                  ) {
                    beforeLastItemTime = moment(
                      _get(beforeLastItem, "to", undefined),
                      formatHours
                    );
                  }
                  const disableHours = Array.from(
                    Array(
                      Number(
                        beforeLastItemTime.format(formatHours).split(":")[0]
                      )
                    ).keys()
                  );
                  let remainningPromotionTime = null;
                  if (
                    canDisableSelectTimeSlot &&
                    day.key === DAY_NUMBER &&
                    item?._id &&
                    Helper.isWorkingTimeActive(item?.from, item?.to)
                  ) {
                    remainningPromotionTime =
                      Helper.calculateRemainningPromotionTime(
                        workingTimeOfWeek
                      );
                  }
                  const isDisableSelectTimeSlot = Boolean(
                    remainningPromotionTime !== null
                  );
                  const isDisableRemove =
                    (index === 0 && day.time.length === 1) ||
                    isDisableSelectTimeSlot;
                  return (
                    <>
                      <div
                        key={item.shift}
                        className="working-time-item-container"
                      >
                        <TimePicker.RangePicker
                          disabled={
                            index !== day.time.length - 1 ||
                            isDisableSelectTimeSlot
                          }
                          disableHours={() => (index === 0 ? [] : disableHours)}
                          onChange={(e) =>
                            handleOnchange({ e, day: day.key, shift: index })
                          }
                          format={formatHours}
                          value={
                            _isEmpty(item.from)
                              ? []
                              : [
                                  moment(
                                    _get(item, "from"),
                                    formatHours
                                  ).isValid()
                                    ? moment(_get(item, "from"), formatHours)
                                    : moment(_get(item, "from")),
                                  moment(
                                    _get(item, "to"),
                                    formatHours
                                  ).isValid()
                                    ? moment(_get(item, "to"), formatHours)
                                    : moment(_get(item, "to")),
                                ]
                          }
                          allowClear={false}
                        />
                        {index === 0 && (
                          <Button
                            disabled={_isEmpty(lastItem.from)}
                            onClick={() =>
                              handleChangeWorkingTimeOfWeek({
                                day: day.key,
                                shift: (_last(day.time).shift || 0) + 1,
                              })
                            }
                            className="add-working-time-btn"
                            type="primary"
                          >
                            <PlusOutlined />
                          </Button>
                        )}
                        <Button
                          disabled={isDisableRemove}
                          onClick={() =>
                            handleRemoveWorkingTimeOfWeek({
                              day: day.key,
                              shift: item.shift,
                              _id: item?._id,
                            })
                          }
                          className="remove-working-time-btn"
                          danger
                          type="primary"
                        >
                          <MinusOutlined />
                        </Button>
                        {index === 0 && (
                          <>
                            <Button
                              disabled={isDisableSelectTimeSlot}
                              onClick={() =>
                                handleSetAlwaysOpen({ day: day.key })
                              }
                              className="check-all-working-time-btn"
                              type="primary"
                            >
                              <CheckOutlined />
                            </Button>
                            <Button
                              disabled={isDisableSelectTimeSlot}
                              onClick={() =>
                                handleSetAlwaysClose({ day: day.key })
                              }
                              className="remove-working-time-btn"
                              danger
                              type="primary"
                            >
                              <CloseOutlined />
                            </Button>
                            <Button
                              disabled={isDisableSelectTimeSlot}
                              onClick={() => _handleApplyForAllWeek(day)}
                              className="apply-for-all-week-working-time-btn"
                            >
                              {i18n.t("menu.applyForAllWeek")}
                            </Button>
                          </>
                        )}
                      </div>
                      {remainningPromotionTime && (
                        <div className="remainning-promotion-time-wrapper">
                          {i18n.t("productDetail.canDisableSelectTimeSlot", {
                            remainningTime: remainningPromotionTime,
                          })}
                        </div>
                      )}
                    </>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

CustomOpenningTime.propTypes = {
  workingTimeOfWeek: PropTypes.array,
  setWorkingTimeOfWeek: PropTypes.func,
  onTimeCustomChange: PropTypes.func,
  titleAlwaysOpen: PropTypes.string,
  titleAlwaysClose: PropTypes.string,
  fieldAlwaysOpen: PropTypes.string,
  fieldAlwaysClose: PropTypes.string,
};

export default CustomOpenningTime;
